export default __webpack_public_path__ + "static/media/potato.e0a41f97.png";